export default "__VITE_ASSET__Do233apV__"